import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DashboardIcon = props => {
  return <FontAwesomeIcon icon="fa-solid fa-chart-line" {...props} />;
};

export default DashboardIcon;
